<app-modal-box class="modal container-style-primary" [hideBackground]="true" [hideHeader]="false" [maxWidth]="1030" [noOverflow]="true">
  <app-coinflip-modal-top [coinflip]="coinflip"></app-coinflip-modal-top>

  <div class="bets">
    <app-coinflip-modal-user [showAnimation]="showUserAnimation" [bet]="coinflip?.host" [coinflip]="coinflip"></app-coinflip-modal-user>
    <app-icon class="swords-icon" [icon]="'swords'" [width]="24"></app-icon>
    <app-coinflip-modal-user [showAnimation]="showUserAnimation" [bet]="coinflip?.part" [coinflip]="coinflip"></app-coinflip-modal-user>
  </div>
  <div class="bottom">
    <a class="hash" routerLink="/provably-fair/coinflip/{{ coinflip?.gameid ?? 0 }}" (click)="modalService.close()">Hash: #{{ coinflip.hash }} </a>
    <div class="bottom-buttons">
      <button class="button font-default-bold red-secondary small" (click)="cancelCoinflip()">Cancel</button>
      <button class="button small black provably-fair-button"><app-icon icon="provably_fair" [width]="16" />Fairness</button>
    </div>
  </div>
</app-modal-box>
